<template>
  <div class="echartDemo">
    <div class="wrap">
      <div style="position:relative">
        <!-- <img src="../../assets/bigLogo.png" style="height: 42px;position: absolute;left: 0px;top: -10px;z-index: 1000;"> -->
        <img src="../../assets/mapbiaoti1.png" class="imgditu">
      </div>
      <div id="map" >
        <div class="map1" ref="myEchart"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import "./china1"
import AreaData from "./data";
import EchartsOption from "./optionConfig";
export default {
  name: "Echarts1Demo",
  props: {
    colorList: {
      type: Array,
      default() {
        return ["rgb(69, 201, 247)"];
      }
    },
    cityConfig: {
      type: Object,
      default() {
        return {
          name: "北京市",
          dataJson: null
        };
      }
    },
  },
  data() {
    return {
      wrap: null, //包裹框
      drawBar: null, // 柱状图
      barWrap: null,
      shaDe: null, // 遮挡层
      myChart: null,
      // 地区坐标
      selfAreaItems: [],
      selfAreaData: [],
      selfOption: {},
      uInfo: [],
      uTan: [],
      uPosition: [],
      areaData: [],
      geOption: {},
      areaItems: []
    };
  },
  created(){
    
    // 获取经纬度
    this.$axios({
      method: 'GET',
      url: '/resource/university/code',
    }).then((res) => {
      this.uInfo = res.data
       //经纬度加到另外一个分组
      this.$axios({
        method: 'POST',
        url: '/statistics/overview',
        contentType: "application/json;charset=utf-8",
        data: JSON.stringify({
          "status": 1,
          "type": 2,
          "year": new Date().getFullYear(),
          "subitem_id": [10, 30]
        }),
        dataType: "json"
      }).then((res) => {
        this.uTan = res.data
        this.uTan.forEach((item) => {
          for(var i = 0; i < this.uInfo.length; i++){
            if(item.university_code === this.uInfo[i].code  && item.campus_name === this.uInfo[i].campus_name){
              item.name = this.uInfo[i].name
              item.latitude = this.uInfo[i].latitude
              item.longitude = this.uInfo[i].longitude
              item.alias = this.uInfo[i].alias
            }
          }
        })
        this.uTan.forEach((item) => {
          item.value = [item.longitude,item.latitude]
          item.DateItems = [{title: item.alias,value: item.avg_value,campus_name: item.campus_name}]
        })
        this.areaItems = this.uTan
        this.areaData = this.uTan
        this.geOption ={
          // title:{ //设置图表标题
          //   text:"高等学校校园碳排放核算及评价平台",
          //   x: "center",
          //   textStyle:{
          //     fontSize: 25
          //   }
          // },
          // backgroundColor: "#fff",
          tooltip: {
          },
          geo: {
                  type: "map",
                  map: "china",
                  // roam: true,
                  // label: {
                  //   normal: {
                  //     show: true,
                  //     textStyle: {
                  //       // color: "rgba(0,0,0,0.4)",
                  //       fontSize: 0
                  //     }
                  //   }
                  // },
                  // itemStyle: {
                  //   normal: {
                  //     borderColor: "rgb(102, 102, 102,0.3)",
                  //     borderWidth: 2,
                  //     borderStyle: "solid"
                  //   },
                  //   emphasis: {
                  //     areaColor: null,
                  //     shadowOffsetX: 0,
                  //     shadowOffsetY: 0,
                  //     shadowBlur: 20,
                  //     borderWidth: 2,
                  //     shadowColor: "rgba(0, 0, 0, 0.5)"
                  //   }
                  // },
                  regions: [
                    {
                      name: "南海诸岛",
                      itemStyle: {
                        // 隐藏地图
                        normal: {
                          opacity: 0, // 为 0 时不绘制该图形
                        }
                      },
                      label: {
                        show: false // 隐藏文字
                      }
                    }
                  ]
          }
        }
        this.init();
      }).catch((error) => {
        console.error('获取建筑数据失败:', error);
        // 设置默认空数据，避免地图渲染错误
        this.uTan = [];
        this.areaItems = [];
        this.areaData = [];
      })
    })  
  },
  beforeUnmount() {
    this.myChart && this.myChart.off("click");
  },
  mounted() {
    let myChart2 = echarts.init(this.$refs.myEchart)
    // echarts.registerMap("chinaMap",mapData)
    let option2 = {
      // title:{ //设置图表标题
      //   text:"高等学校校园碳排放核算及评价平台",
      //   x: "center",
      //   textStyle:{
      //     fontSize: 25,
      //   }
      // },
      geo:{
        type:"map",
        map:"china",
        // roam:true,
        regions: [
          {
            name: "南海诸岛",
            itemStyle: {
              // 隐藏地图
              normal: {
                opacity: 0, // 为 0 时不绘制该图形
              }
            },
            label: {
              show: false // 隐藏文字
            }
          }
        ]
      }
    }
    myChart2.setOption(option2)
  },
  methods: {
    getuTan() {
      return this.uTan
    },
    loadMap(mapName, data) {
      if (data) {
        echarts.registerMap(mapName, data);
      }
    },
    init() {
      this.selfAreaData = JSON.stringify(this.areaData)&&JSON.parse(JSON.stringify(this.areaData));
      this.selfOption = JSON.stringify(this.geOption)&&JSON.parse(JSON.stringify(this.geOption));
      this.selfColor = JSON.stringify(this.colorList)&&JSON.parse(JSON.stringify(this.colorList));
      // this.selfOption = JSON.stringify(this.option)&&JSON.parse(JSON.stringify(this.option));
      this.myChart = echarts.init(this.$refs.myEchart);
      if (this.cityConfig.dataJson) {
        this.loadMap(this.cityConfig.name, this.cityConfig.dataJson);
      }
      this.selfAreaItems = JSON.stringify(this.areaItems)&&JSON.parse(JSON.stringify(this.areaItems));
      // window.onresize = this.myChart.resize;
      this.myChart.setOption(this.selfOption);
      // 拖拽跟缩放重置
      // let throttledRenderEachCity = this.throttle(this.renderItems, 0);
      // this.myChart.on("geoRoam", throttledRenderEachCity);
      this.renderItems();
      // this.itemonClick();
    },
    // 缩放和拖拽
    throttle(fn, delay, debounce) {
      let currCall;
      let lastCall = 0;
      let lastExec = 0;
      let timer = null;
      let diff;
      let scope;
      let args;
      delay = delay || 0;
      function exec() {
        lastExec = new Date().getTime();
        timer = null;
        fn.apply(scope, args || []);
      }

      let cb = function() {
        currCall = new Date().getTime();
        scope = this;
        args = arguments;
        diff = currCall - (debounce ? lastCall : lastExec) - delay;

        clearTimeout(timer);

        if (debounce) {
          timer = setTimeout(exec, delay);
        } else {
          if (diff >= 0) {
            exec();
          } else {
            timer = setTimeout(exec, -diff);
          }
        }

        lastCall = currCall;
      };

      return cb;
    },
    // 填充 地图点位
    renderItems() {
      let option = Object.assign(this.selfOption, {
        xAxis: [],
        yAxis: [],
        grid: [],
        series: [],
        tooltip: []
      });
      this.selfAreaData.forEach((item, idx) => {
        // let nodeCoord = this.selfAreaItems[0].value
        // let nodeCoord = this.selfAreaItems[item.areaName]
        let nodeCoord = []
        for(var i = 0; i < this.selfAreaItems.length; i++){
          if(item.name === this.selfAreaItems[i].name){
            nodeCoord = this.selfAreaItems[i].value;
          }
        }
        // nodeCoord = [nodeCoord[0],nodeCoord[1]]
        nodeCoord = [nodeCoord[0]+1.2,nodeCoord[1]+1.6]
        let coord = this.myChart.convertToPixel("geo", nodeCoord);
        let titleItems = (item.DateItems || []).map(i => i.title);
        let itemData = (item.DateItems || []).map(i => Number(i.value));
        if (coord) {
          option.xAxis.push({
            id: idx + item.alias,
            gridId: idx + item.alias,
            type: "category",
            name: item.alias,
            nameLocation: "middle",
            nameGap: 3,
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: false
            },
            axisLine: {
              onZero: false,
              lineStyle: {
                color: "#666"
              }
            },
            data: titleItems,
            z: 100
          });
          option.yAxis.push({
            id: idx + item.alias,
            gridId: idx + item.alias,
            type: "value",
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: false
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "red"
              }
            },
            min: 0,
            max: 0.02
          });
          option.grid.push({
            id: idx + item.alias,
            width: 10,
            height: 40,
            left: coord[0] - 15,
            top: coord[1] - 15,
            z: 100
          });
          option.series.push({
            id: idx + item.alias,
            type: "bar",
            xAxisId: idx + item.alias,
            yAxisId: idx + item.alias,
            barGap: 0,
            barCategoryGap: 0,
            data: item.DateItems,
            z: 100,
            itemStyle: {
              normal: {
                color: params => {
                  // build a color map as your need.
                  let color = this.selfColor[params.dataIndex];
                  return color;
                }
              },
              opacity: 0,
              emphasis: {
                label: {
                  show: false
                }
              }
            }
          });
          option.tooltip.push({
            trigger: 'item',
            formatter(params){
              return `<p style="margin: 0">${params.name}</p>生均水资源消耗碳排放量: ${(params.value*1000).toFixed(3)} CO2·kg/人·a`
            }
          })
        }
      });
      this.myChart.setOption(option);
    },
    // 点击显示柱状图
    // itemonClick() {
    //   this.myChart.on("click", e => {
    //     if (e.componentSubType == "bar") {
    //       this.barWrap = document.createElement("div");
    //       this.drawBar = document.createElement("div");
    //       this.wrap = document.getElementsByClassName("wrap")[0];
    //       // 先清除所有柱状图
    //       // $(".tongJiTu").remove();
    //       // 创建遮挡层
    //       this.creatWrap();
    //       // 创建柱状图容器
    //       this.barWrap.id = "bar-wrap";
    //       this.barWrap.className = "bar-wrap";
    //       this.drawBar.className = "zhuzhuang";
    //       let divX = this.getMousePos()["x"];
    //       let divY = this.getMousePos()["y"];
    //       this.barWrap.setAttribute(
    //         "style",
    //         `width: 350px; height: 180px;border: 1px solid #ccc;position:absolute;top: ${divY}px;left:${divX}px`
    //       );
    //       this.drawBar.setAttribute("style", `width: 100%; height: 100%`);
    //       // 创建柱状图
    //       this.wrap.appendChild(this.barWrap);
    //       this.barWrap.appendChild(this.drawBar);
          // this.zhuZhuangTu(e);
    //       // // 点击遮挡层消失
    //       this.clearWrap();
    //     }
    //     return;
    //   });
    // },
    // 获取横纵坐标
    getMousePos(e) {
      e = event || window.event;
      let x = e.clientX;
      let y = e.clientY;
      return { x, y };
    },
    // 生成柱状图
    zhuZhuangTu(e) {
      let index = e.seriesIndex;
      let bar = echarts.init(this.drawBar);
      let xTitle = this.selfAreaData[index].DateItems.map(i => i.title);
      let yValue = this.selfAreaData[index].DateItems.map(i => i.value);
      let option = {
        backgroundColor: "rgba(255,255,255,.3)",
        legend: {
          data: xTitle
        },
        xAxis: [
          {
            type: "category",
            data: xTitle
          }
        ],
        yAxis: [
          {
            splitLine: {
              show: false
            },
            type: "value"
          }
        ],
        series: [
          {
            type: "bar",
            itemStyle: {
              normal: {
                color: function(params) {
                  let colorList = ["#F75D5D", "#59ED4F", "#4C91E7"];
                  return colorList[params.dataIndex];
                },
                label: {
                  show: true,
                  position: "top",
                  textStyle: {
                    color: "#000"
                  }
                }
              }
            },
            data: yValue
          }
        ]
      };
      bar.setOption(option);
    },
    // 生成遮挡层
    creatWrap() {
      this.shaDe = document.createElement("div");
      this.shaDe.className = "shaDe";
      this.wrap.appendChild(this.shaDe);
    },
    // 去掉遮挡层
    clearWrap() {
      this.shaDe.addEventListener(
        "click",
        () => {
          this.shaDe.remove();
          this.barWrap.remove();
          this.drawBar.remove();
          return false;
        },
        false
      );
    }
  }
};
</script>

<style lang="less">
.shaDe {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 1);
}
.map {
  height: 600px;
  width: 100%;
}
.map1 {
  height: 600px;
  width: 100%;
  margin-top: 50px;
}
.imgditu {
  height: 60px;
  position: absolute;
  left: 20%;
  top: -50px;
}
</style>
